import React from 'react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import { Header, Grid, Input, Icon } from 'semantic-ui-react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Waitingstocksdetails from './waitingstocksdetails';
import Salesorderdetails from './salesorderdetails';
import Pendingdetails from './pendingdetails';
import Stocksdetails from './stockdetails';
import Info from '@material-ui/icons/Info';
import ReadCookie from '../../../functions/readcookies';
import SuccessDialog from '../../successdialog';
import SpareDetails from './sparedetails';

class Mrp extends React.Component {

  state = {
    openDetails: false,
    fullWidth: true,
    maxWidth: 'sm',
    data: []
  }

  getMrp() {
    let data = this.props.partcodeOption;
    let tax, hsn_code, dnp, mrp;
    console.log(this.props.aliasId);
    console.log(this.props.brand_id);
    try {
      for (var i = 0; i < data.length; i++) {
        if (data[i].id == this.props.aliasId && data[i].brand_id == this.props.brand_id)  {
          mrp = data[i].mrp;
          dnp = data[i].dnp;
          hsn_code = data[i].hsn_code;
          tax = data[i].tax;
        }
      }
    } catch (e) {
      console.log(e);
    }
    this.setState({
      mrp: mrp,
      dnp: dnp,
      hsn_code: hsn_code,
      tax: tax,
      openDetails: true,
      data: data,
      samplerequestStocks: this.props.sampleRequestqty
    })
  }

  handleClose = () => {
    this.setState({ openDetails: false });
  };

  edit = () => {
    this.setState({ edit: true });
  };

  onChange = (type) => (e, {value}) => {
    this.setState({
      [type]: value
    })
  }

  save() {
    let context = this;
    let oldData = this.state.data;
    context.setState({
      load: true,
      message: 'Editing Mrp!!!'
    });
    let data1 = { 'id': this.state.id, 'mrp': this.state.mrp,
                  'partno': this.props.partno, 'brand': this.props.brandId };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchasedetail/editmrp.php',
      success: function(data)
      {
        context.setState({ load: false })
        if (data == 1) {
          for (var i = 0; i < oldData.length; i++) {
            if (oldData[i].id == context.state.id) {
              oldData[i].mrp = context.state.mrp;
            }
          }
          context.props.setPartcode(oldData)
          context.props.updateItem(context.state.mrp);
          context.setState({
            data: oldData,
            edit: false,
          });
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  move() {
    let context = this;
    let allItems = this.props.allItems;
    let stocks = this.state.samplerequestStocks;
    let itemid = this.props.itemId;
    let item = [];
    allItems.map((z) => {
      if (z.id == itemid) {
          item.push(z);
      }
    });

    item = JSON.stringify(item);
    let cook = (ReadCookie("vaigai"));
    let by = cook.id;
    let data1 = { 'userId': by, 'item': item, 'stocks': stocks };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/samplepurchaserequest.php',
      success: function(data)
      {
        console.log(data);
        if (data == 1) {
          context.setState({ successDialog: true, message: 'Success' });
          context.handleClose();
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  close() {
    this.setState({ successDialog: false })
  }

  render() {
    let i = 1;
    return (
      <div>
        <Info style={{fontSize: 18}} onClick={ () => { this.getMrp() } } />
        <Loading load={this.state.load} message={this.state.message} />
        <React.Fragment>
        { this.state.openDetails ?
          (
            <Dialog  fullWidth={this.state.fullWidth}
              maxWidth={this.state.maxWidth}  open={this.state.openDetails}
              onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
              <DialogTitle id="max-width-dialog-title">Related Info</DialogTitle>
              <DialogContent>
                { this.state.data.map((z) => {
                  if (i == 1) {

                      let mrp = z.mrp;
                      let tax = z.tax;
                      try {
                        mrp = Number(mrp);
                        tax = Number(tax);
                        mrp = (mrp+((mrp * tax)/100)).toFixed(2);
                      } catch (e) {

                      }
                      if (z.brand_id == this.props.brand_id && this.props.aliasId == z.id) {
                        i++;
                          if (this.state.edit) {
                            return (
                              <Grid>
                                <Grid.Column mobile={5} tablet={5} computer={10}>
                                  <Input fluid focus value={this.state.mrp} onChange={this.onChange('mrp')} />
                                </Grid.Column>
                                <Grid.Column mobile={5} tablet={5} computer={3}>
                                  <Button variant="outlined"  fullWidth onClick={this.save.bind(this)}>Save</Button>
                                </Grid.Column>
                                <Grid.Column mobile={5} tablet={5} computer={3}>
                                  <Button variant="outlined" fullWidth onClick={ () => { this.setState({ edit: false })} }>Cancel</Button>
                                </Grid.Column>
                              </Grid>
                            );
                          }
                          else {
                            return (
                              <Grid>
                                <Grid.Column mobile={5} tablet={5} computer={4}>
                                  <b>MRP: </b><br/><p style={{color: 'green'}}>{mrp}</p>
                                </Grid.Column>
                                <Grid.Column mobile={5} tablet={5} computer={4}>
                                  <b>TAX: </b><br/><p style={{color: 'green'}}>{z.tax}</p>
                                </Grid.Column>
                                <Grid.Column mobile={5} tablet={5} computer={4}>
                                  <b>HSN CODE:</b><br/><p style={{color: 'green'}}>{z.hsn_code}</p>
                                </Grid.Column>
                                <Grid.Column mobile={5} tablet={5} computer={4}>
                                  <SpareDetails partno={this.props.partno} />
                                </Grid.Column>
                                <Grid.Column mobile={16} tablet={16} computer={16}>
                                  <Stocksdetails partno={this.props.partno} brandId={z.brand_id} />
                                </Grid.Column>
                                <Grid.Column mobile={16} tablet={16} computer={16}>
                                  <Waitingstocksdetails partno={this.props.partno} brandId={z.brand_id} />
                                </Grid.Column>
                                <Grid.Column mobile={16} tablet={16} computer={16}>
                                  <Salesorderdetails partno={this.props.partno} brandId={z.brand_id} />
                                </Grid.Column>
                                <Grid.Column mobile={16} tablet={16} computer={16}>
                                  <Pendingdetails partno={this.props.partno} brandId={z.brand_id} />
                                </Grid.Column>
                              </Grid>
                            );
                        }
                      }
                    }
                  })
                }
              </DialogContent>
              <DialogActions style={{display: this.props.viewDisplay}}>
                <Input value={this.state.samplerequestStocks} style={{display: this.props.display}}
                       onChange={this.onChange('samplerequestStocks')} />
                <Button style={{display: this.props.display}} onClick={this.move.bind(this)} color="primary">
                  Move to purchase request sample
                </Button>
                <Button onClick={this.edit} style={{display: 'none'}} color="primary">
                  Edit
                </Button>
                <Button onClick={this.handleClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          ):
          (
            <div></div>
          )
        }
      </React.Fragment>
      <SuccessDialog message={this.state.message} load={this.state.successDialog}
        close={this.close.bind(this)} />

        
      </div>
    );
  }
}

export default Mrp;
